export default {
  charsPerSecond: 8
}

export const KEY_CONVERSATION_ID = 'inovia-conversation-id'